import React, { useState } from 'react';

import { SquadraTabella, Problema } from '../api/types';
import { sortClassifica } from '../api';
import { usePunteggi } from '../reducers';

import './TabellaPunteggiMinimal.scss'

interface ownProps {
  punteggi: number[],
  dettagli_problemi: Problema[],
  classifica: SquadraTabella[]
  storia: ReturnType<typeof usePunteggi>["states"]
}

interface OldPosMap {
  [pk: string]: number
}


const TabellaPunteggiMinimal = (props: ownProps) => {
  const { dettagli_problemi, punteggi, classifica: classifica_unsorted, storia: states_vec } = props;
  const [sortDir, setSortDir] = useState<1 | -1>(1);
  const [sortField, setSortField] = useState<"p" | "n">("p");


  let old_pos: OldPosMap = {};
  if (states_vec?.length > 3) {
    const old_state = states_vec[3];
    old_pos = old_state.classifica.reduce(
      (dict, sq) => {
        dict[sq.id.toString()] = sq.posizione;
        return dict;
      }, {} as OldPosMap
    )
  }

  const classifica = sortClassifica(classifica_unsorted, sortDir, sortField, 0);
  let problema_completo = [];
  for (let i = 0; i < dettagli_problemi.length; i++) {
    let cusu: any = Object.assign({}, dettagli_problemi[i]);
    cusu.punteggio = (punteggi) ? punteggi[i] : 0;
    problema_completo.push(cusu);
  }
  return (
    <>
      <div id="tabella-punteggi-minimale">
        <table className="table table-bordered table-striped table-hover text-nowrap table-responsive-lg" style={{ tableLayout: "fixed" }}>
          <col width="40px" />
          <col width="230px" />
          <col width="60px" />
          <thead className="thead-dark">
            <tr>
              <th key="1"
                onClick={() => { setSortField("p"); setSortDir(dir => dir * -1 as 1 | -1); }}>
                <i className="fa fa-sort" /></th>
              <th key="2"
                onClick={() => { setSortField("n"); setSortDir(dir => dir * -1 as 1 | -1); }}>
                <i className="fa fa-sort" /> Squadra
              </th>
              <th key="0">
                Punti
              </th>
            </tr>
          </thead>
          <tbody>
            {classifica.map(
              (squadra: SquadraTabella) => {
                const extra = [1, 2, 3].includes(squadra.posizione) ? "font-weight-bold" : "";
                const cambio = old_pos[squadra.id.toString()]
                let cambio_icon = undefined;
                if (cambio) {
                  if (squadra.posizione < cambio) {
                    // Posizione guadagnata
                    cambio_icon = <i className="fa fa-arrow-up text-success" />
                  } else if (squadra.posizione > cambio) {
                    // Posizione persa
                    cambio_icon = <i className="fa fa-arrow-down text-danger" />
                  }
                }
                return (
                  <tr key={squadra.id}>
                    <td className={extra} style={{ width: '45px' }}>
                      {cambio_icon}{squadra.posizione}
                    </td>
                    <td className={extra}>
                      {squadra.nome}
                    </td>
                    <td className={extra}>
                      {squadra.totale}
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TabellaPunteggiMinimal;
